// extracted by mini-css-extract-plugin
module.exports = {"installServiceWrapper":"v1_installServiceWrapper__YFoJ7"};